import TabInfo from '../../../common/TabController/TabInfo';
import NewFreeEnergyJob from './NewFreeEnergyJob';
import FreeEnergyJobs from './FreeEnergyJobs';
import FreeEnergyResults from './FreeEnergyResults';

const tabs = [
    new TabInfo(
        'new_fep_tab',
        'New Job',
        NewFreeEnergyJob,
        {
            TabPanelProps: { sx: { p: 1 } }, // override padding level
        }
    ),
    new TabInfo(
        'fep_jobs_tab',
        'Jobs',
        FreeEnergyJobs,
        {
            TabPanelProps: { sx: { p: 1 } }, // override padding level
        }
    ),
    new TabInfo(
        'fep_results_tab',
        'Results',
        FreeEnergyResults,
        {
            TabPanelProps: {
                style: {
                    flex: 1,
                    flexDirection: 'column',
                },
                sx: { p: 1 }, // override padding level
            },
        }
    ),
];
export default tabs;
